module.exports = __webpack_public_path__ + "img/a4ac557ae72c9e625b04f32000050fec.b397f90e.png";